var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoBookings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9861 0.500728C53.0304 0.435762 63.6564 4.72086 71.5659 12.4292C75.5091 16.2802 78.6546 20.8705 80.8228 25.9378C82.9909 31.0051 84.139 36.45 84.2016 41.9613C84.2642 47.4726 83.24 52.9422 81.1875 58.0574C79.135 63.1726 76.0945 67.8332 72.2398 71.7727C70.1874 73.8684 67.9152 75.7368 65.4624 77.3456C57.4373 82.6061 47.864 84.9859 38.3099 84.0955C28.7576 83.2051 19.7906 79.0985 12.8765 72.4479C5.06402 64.5914 0.624626 53.9971 0.502584 42.918C0.380523 31.8371 4.58682 21.1459 12.2266 13.1188L12.2285 13.1168L12.5538 12.7712C20.3716 4.97356 30.9442 0.56568 41.9861 0.500728ZM66.1935 65.884L66.1971 65.8803C69.2824 62.7302 71.717 59.0034 73.362 54.9125C75.007 50.8215 75.8301 46.4467 75.7843 42.0377C75.7385 37.6287 74.8248 33.2718 73.0952 29.2159C71.3657 25.1601 68.8542 21.4845 65.7042 18.3993C62.5542 15.314 58.8273 12.8794 54.7364 11.2344C50.6455 9.58943 46.2706 8.76634 41.8616 8.81211C32.9576 8.90455 24.4549 12.5302 18.224 18.8914C11.9576 25.2168 8.46038 33.7724 8.50168 42.6763C8.54299 51.5807 12.1199 60.104 18.4455 66.3712C24.771 72.6384 33.3272 76.136 42.2316 76.0947C51.1356 76.0534 59.6586 72.4768 65.9257 66.1518C65.9259 66.1515 65.9262 66.1512 65.9265 66.1509L66.1935 65.884Z",
    fill: "#D5E1FF",
    stroke: "#D5E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3867 112.679L68.3637 80.6473C70.6901 79.0295 72.8684 77.2078 74.8727 75.2036L74.8727 75.2036L75.2653 74.8109L75.2661 74.8101C77.1463 72.9209 78.8683 70.881 80.4148 68.7109L112.429 96.7158L96.3867 112.679Z",
    fill: "#D5E1FF",
    stroke: "#D5E1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3086 53.8577C43.1623 48.1154 46.7397 48.3048 52.6475 53.8577",
    stroke: "#D5E1FF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.624 38.124C37.624 40.5524 35.786 42.4651 33.5854 42.4651C31.3849 42.4651 29.5469 40.5524 29.5469 38.124C29.5469 35.6955 31.3849 33.7828 33.5854 33.7828C35.786 33.7828 37.624 35.6955 37.624 38.124Z",
    fill: "#D5E1FF",
    stroke: "#D5E1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3833 38.124C56.3833 40.5524 54.5453 42.4651 52.3447 42.4651C50.1442 42.4651 48.3062 40.5524 48.3062 38.124C48.3062 35.6955 50.1442 33.7828 52.3447 33.7828C54.5453 33.7828 56.3833 35.6955 56.3833 38.124Z",
    fill: "#D5E1FF",
    stroke: "#D5E1FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.6475,
    cy: 37.5189,
    r: 6.76172,
    stroke: "#D5E1FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.8882,
    cy: 37.5189,
    r: 6.76172,
    stroke: "#D5E1FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.697,
    y1: 27.6858,
    x2: 33.4062,
    y2: 24.6552,
    stroke: "#D5E1FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48.1272,
    y1: 23.7983,
    x2: 56.2924,
    y2: 26.6966,
    stroke: "#D5E1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBookings);
export default __webpack_public_path__ + "static/media/noBookings.56144eb5.svg";
export { ForwardRef as ReactComponent };